import Phaser from "phaser";
import { NATIVE_HEIGHT, NATIVE_WIDTH } from "./config";
import { LanguageService } from "./i18n";
import { BootScene } from "./scenes/BootScene";
import { LauncherScene } from "./scenes/LauncherScene";
import { TutorialScene } from "./scenes/TutorialScene";
import { RunnerScene } from "./scenes/RunnerScene";
import { EndScene } from "./scenes/EndScene";
import { ProfileTooltipScene } from "./scenes/ProfileTooltipScene";
import { ShopScene } from "./scenes/ShopScene";
import { SidequestAuthorScene } from "./scenes/SidequestAuthorScene";

// Resolve the participant-facing UI language (DE default, EN if the browser
// asks for it, persisted in localStorage after first run). Must run before
// the Phaser game boots so every scene's first paint is in the right language.
LanguageService.boot();

// Roamling v0.2 — Phaser game entry.
//
// Scale: render at the native 384x216 (PRD §7), integer-scaled to fit the
// browser window via Phaser's Scale Manager. Pixel-art mode ensures no
// bilinear smoothing on the scaled canvas.
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "app",
  backgroundColor: "#0a0510",
  pixelArt: true,
  roundPixels: true,
  width: NATIVE_WIDTH,
  height: NATIVE_HEIGHT,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    gamepad: true,
  },
  physics: {
    default: "arcade",
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, LauncherScene, TutorialScene, RunnerScene, EndScene, ShopScene, SidequestAuthorScene, ProfileTooltipScene],
};

new Phaser.Game(config);
